import type FeatureProvider from "src/features/FeatureProvider"
import FeatureFlagIds from "src/features/FeatureFlagIds"

export type SampleDesign = "classic" | "story"

const DESIGNS: SampleDesign[] = ["classic", "story"]

/** The flag decides; `?design=` in the address overrides it so either can be looked at. */
export function sampleDesignFor(featureProvider: FeatureProvider | undefined, override: string | null): SampleDesign {
    if (override && DESIGNS.includes(override as SampleDesign)) return override as SampleDesign
    const flagged = featureProvider?.getFeatureFlag(FeatureFlagIds.SAMPLE_REPORT_DESIGN).value
    return DESIGNS.includes(flagged) ? flagged : "classic"
}
